/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/**
 * Actions Types
 */
export enum EmploymentRequestTypes {
  EMPLOYMENT_REQUEST_REQUEST = '@request/EMPLOYMENT_REQUEST_REQUEST',
  EMPLOYMENT_REQUEST_SUCCESS = '@request/EMPLOYMENT_REQUEST_SUCCESS',
  EMPLOYMENT_REQUEST_FAILURE = '@request/EMPLOYMENT_REQUEST_FAILURE',
  EMPLOYMENT_REQUEST_RESET = '@request/EMPLOYMENT_REQUEST_RESET',
}

/**
 * State Types
 */
export interface IEmploymentRequestState {
  readonly loading: boolean;
  readonly error: boolean;
}
